import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=1fbc4ab2&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=ts"
export * from "./Selector.vue?vue&type=script&lang=ts"
import style0 from "./Selector.vue?vue&type=style&index=0&id=1fbc4ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbc4ab2",
  null
  
)

export default component.exports